/*
 * ddd-auth.js — single source of truth for the DDD member session.
 *
 * Both ddd-product.js (site-wide account-icon login) and ddd-membership.js
 * (membership-page modal) delegate getSession / setSession / clearSession /
 * getRawSession to window.DDDAuth, so the session layer can never drift
 * between them again. (Drift here — a missing setSession in one file — is
 * exactly what produced the "could not reach the server" login bug.)
 *
 * Loaded in <head> with defer so it runs before either consumer (both are
 * deferred and appear later in the document, so document-order execution
 * guarantees this runs first). Self-guarded so re-inclusion is harmless.
 */
window.DDDAuth = window.DDDAuth || (function () {
  "use strict";
  var SESSION_KEY = "ddd_session_v1";
  var LEEWAY_MS = 60000;

  function getSession() {
    try {
      var raw = localStorage.getItem(SESSION_KEY);
      if (!raw) return null;
      var s = JSON.parse(raw);
      if (!s || !s.accessToken || !s.expiresAt || Date.now() > s.expiresAt - LEEWAY_MS) {
        localStorage.removeItem(SESSION_KEY);
        return null;
      }
      return s;
    } catch (e) {
      return null;
    }
  }

  // Read the stored session WITHOUT the expiry check (so a near-expired
  // session's refresh token is still reachable for renewal).
  function getRawSession() {
    try {
      var raw = localStorage.getItem(SESSION_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function setSession(payload) {
    var s = {
      accessToken: payload.accessToken,
      refreshToken: payload.refreshToken,
      expiresAt: Date.now() + (payload.expiresIn || 3600) * 1000,
      user: payload.user || null,
    };
    try {
      localStorage.setItem(SESSION_KEY, JSON.stringify(s));
    } catch (e) {}
    return s;
  }

  function clearSession() {
    try {
      localStorage.removeItem(SESSION_KEY);
    } catch (e) {}
  }

  return {
    SESSION_KEY: SESSION_KEY,
    getSession: getSession,
    getRawSession: getRawSession,
    setSession: setSession,
    clearSession: clearSession,
  };
})();
